<template>
  <div class="project-template">
    <div class="project-template-title">{{ title }}</div>
    <div class="project-template-left">
      <div class="left-content">
        <slot name="leftContent"></slot>
      </div>
      <div class="btn-list">
        <a-button-group>
          <!-- <component :is="customIcon" fontSize="30px" ></component> -->
          <a-button class="btn1" @click="$emit('lastClick')">上一步</a-button>
          <a-button type="primary" class="btn2" @click="$emit('nextClick')">
            {{ nextBtnText }}
          </a-button>
        </a-button-group>
      </div>
    </div>
    <div class="project-template-right">
      <div class="right-content">
        <slot name="rightContent"></slot>
      </div>
    </div>
  </div> 
</template>

<script>
import IconBack from '@comp/Icon/IconBack'
import AIHelper from '@comp/Icon/AIHelper'
export default {
  name: 'ProjectTemplate',
  components: { IconBack, AIHelper },
  props: {

    // leftTitle: {
    //   type: String,
    //   default: '标题1'
    // },
    title: {
      type: String,
      required: true,
      default: '标题'
    },
    nextBtnText: {
      type: String,
      default: '下一步'
    }
  },
  data() {
    return {
      customIcon: 'ai-helper' // 替换为你的自定义图标类名
    };
  },

}
</script>

<style scoped lang="less">
.project-template {
  display: grid;
  grid-template-columns: 375px calc(100vw - 92px - 375px);
  grid-template-rows: 56px calc(100vh - 56px);
}

.project-template-title {
  grid-column-start: 1;
  grid-column-end: 3;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  color: white;
}

.project-template-left {
  position: relative;
  border-left: 1px dashed rgba(255, 255, 255, 0.3);
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  overflow-y: auto;

  .left-content {
    padding: 20px;
    height: calc(100vh - 56px - 72px);
    overflow: auto
  }

  .btn-list {
    padding: 20px 0;
    text-align: center;

    .icon {
      padding: 0 30px;
      color: white;
      background: rgba(255, 255, 255, 0.15);
      border: none;
      border-radius: 21px 0 0 21px !important;
    }

    .btn1 {
      padding: 0 30px;
      color: white;
      background: rgba(255, 255, 255, 0.15);
      border: none;
      border-radius: 21px 0 0 21px !important;
    }

    .btn2 {
      padding: 0 30px;
      color: white;
      background: linear-gradient(90deg, #376EFF 0%, #DE5DFE 100%);
      border: none;
      border-radius: 0 21px 21px 0 !important;
    }
  }
}

.project-template-right {
  background: url(~@/assets/bg02.png) center center no-repeat;

  .right-content {
    padding: 20px;
    height: calc(100vh - 56px);
    overflow: auto;
    position: relative;
  }
}
</style>
